const ManagerAttendance = () => {
    return (
      <div className="p-6 bg-white rounded-lg shadow-md min-h-[80vh]">
        <h2 className="text-2xl font-bold mb-4 text-blue-600">Team Attendance</h2>
        <p>View attendance for your team members.</p>
      </div>
    );
  };
  
  export default ManagerAttendance;
  